import React from "react";
import { notification, Modal, Input, Button,Tag } from "antd";
import { Table } from "ant-table-extensions";
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { MdNavigateNext, MdNavigateBefore } from "react-icons/md";
import { Row, Col } from 'react-bootstrap';
import { FaTrashAlt, FaTrashRestoreAlt } from 'react-icons/fa';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import Auxiliary from "util/auxiliary";
import PageHeader from "components/PageHeader";

import {
  listEventImages,
  deleteEventImage,
  searchEventImage,
  resetEventImageType
} from "../../../appRedux/actions/eventImages";

const { Search } = Input;
const getRandomuserParams = params => ({
  results: params.pagination.pageSize,
  page: params.pagination.current,
  ...params,
});

const itemRender = (current, type, originalElement) => {
  if (type === 'prev') {
    return <Button className="ant-paginatio-button"><MdNavigateBefore className="icon-size" /> Previous</Button>;
  }
  if (type === 'next') {
    return <Button className="ant-paginatio-button">Next <MdNavigateNext className="icon-size" /></Button>;
  }
  return originalElement;
}

class EventImageList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentInstance: this,
      record: null,
      previewVisible: false,
      previewImage: '',
      previewTitle: '',
      eventImageList: [],
      pagination: {
        current: 1,
        pageSize: 10
      }
    }

    this.columns = [{
      title: 'Name',
      dataIndex: 'image',
      key: 'image',
      width: 150,
      sorter: (a, b) => a.image.originalName.length - b.image.originalName.length,
      sortDirections: ['descend', 'ascend'],
      render: (image) => (
        <span
          className="gx-link"
          onClick={(e) => { this.onClickImageName(image, e); }}>
          {image.originalName}
        </span>
      ),
    }, {
      title: 'Type',
      dataIndex: 'eventImageType',
      key: 'eventImageType',
      sorter: (a, b) => a.eventImageType.name.length - b.eventImageType.name.length,
      sortDirections: ['descend', 'ascend'],
      render: (eventImageType) => { return (<span>{eventImageType.name}</span>) }
      }, {
        title: 'Status',
        dataIndex: 'isDeleted',
        key: 'isDeleted',
        sorter: (a, b) => a.isDeleted - b.isDeleted,
        sortDirections: ['descend', 'ascend'],
        render: (isDeleted) => {
          return (<Tag color={isDeleted ? "warning" : 'processing'}>
            {isDeleted ? 'Deleted' : 'Active'}
          </Tag>)
        },
        filters: [
          {
            text: 'Active',
            value: false
          },
          {
            text: 'Deleted',
            value: true
          }
        ],
        filterMultiple: false,
        onFilter: (value, record) => record.isDeleted === value
      }, {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
      sortDirections: ['descend', 'ascend'],
      render: (createdAt) => { return (<span>{moment(createdAt).format('MM-DD-YYYY hh:mm a')}</span>) }
    }, {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
      sortDirections: ['descend', 'ascend'],
      render: (updatedAt) => { return (<span>{moment(updatedAt).format('MM-DD-YYYY hh:mm a')}</span>) }
    }, {
      title: 'Action',
      key: 'action',
      width: 150,
      render: (text, record) => (
        !record.isDeleted ?
          <span title="Delete" className="gx-link delete-color" onClick={(e) => { this.onConfirmDelete(record); }}>
            <FaTrashAlt className="icon-size" />
          </span>
          :
          <span title="Restore" className="gx-link delete-color" onClick={(e) => { this.onConfirmRestore(record); }}>
            <FaTrashRestoreAlt className="icon-size" />
          </span>
    
      ),
    }]

  };


  componentDidMount() {
    const { pagination } = this.state;
    this.fetch({ pagination });
  }

  static getDerivedStateFromProps(nextProps, state) {
    if (nextProps.eventImage) {
      if (nextProps.eventImage.messageId === 204) {
        return {
          eventImageList: nextProps.eventImage.event_images.data,
          pagination: {
            current: nextProps.eventImage.event_images.current,
            pageSize: nextProps.eventImage.event_images.pageSize,
            total: nextProps.eventImage.event_images.totalCount
          }
        }
      } else if (nextProps.eventImage.messageId === 200) {
        notification['success']({
          message: 'Success',
          description: nextProps.eventImage.alertMessage
        });
        let pagination = state.pagination;
        state.currentInstance.fetch({ pagination });
        nextProps.resetEventImageType();
      } else if (nextProps.eventImage.messageId === 203) {
        notification['error']({
          message: 'Alert!!',
          description: nextProps.eventImage.alertMessage
        });
        nextProps.resetEventImageType();
      }
      return true;
    }
    return null;
  }

  onClickImageName = (image, e) => {
    this.setState({
      previewImage: image.location,
      previewVisible: true,
      previewTitle: image.originalName
    });
  }

  handleCancel = () => this.setState({ previewVisible: false });

  onConfirmDelete(record) {
    this.setState({
      record: record
    }, () => {
      Modal.confirm({
        title: 'Delete',
        centered: true,
        icon: <ExclamationCircleOutlined />,
        content: 'Are you sure you want to delete ' + record.image.originalName + ' for type ' + record.eventImageType.name + '?',
        okText: 'Delete',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk: this.onDeleteRecord
      });
    })
  }

  onDeleteRecord = () => {
    const { record } = this.state;
    const { authUser } = this.props.auth;
    let data = {
      _id: record._id,
      filename: record.image.key,
      isDeleted: true
    }
    this.props.deleteEventImage(authUser.token, data);
  }

  onConfirmRestore(record) {
    this.setState({
      record: record
    }, () => {
      Modal.confirm({
        title: 'Restore',
        centered: true,
        icon: <ExclamationCircleOutlined />,
        content: 'Are you sure you want to restore ' + record.name + '?',
        okText: 'Restore',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk: this.onRestoreRecord
      });
    })
  }

  onRestoreRecord = () => {
    const { record } = this.state;
    const { authUser } = this.props.auth;
    let data = {
      _id: record._id,
      isDeleted: false
    }
    this.props.deleteEventImage(authUser.token, data);
  }


  handleTableChange = (pagination, filters, sorter) => {
    this.fetch({
      sortField: sorter.field,
      sortOrder: sorter.order,
      pagination,
      ...filters
    });
  };

  fetch = (params = {}) => {
    let pageInfo = getRandomuserParams(params);
    const { authUser } = this.props.auth;
    if (authUser && pageInfo) {
      let inputJson = {
        current: pageInfo.pagination.current,
        pageSize: pageInfo.pagination.pageSize
      }
      if (pageInfo.isDeleted && pageInfo.isDeleted.length > 0) {
        inputJson.isDeleted = pageInfo.isDeleted[0] ? 'TRUE' : 'FALSE';
      }
      this.props.listEventImages(authUser.token, inputJson);
    }
  }

  onSearch = value => {
    if (value) {
      const { pagination } = this.state;
      let inputJson = {
        searchString: value,
        current: 1,
        pageSize: pagination.pageSize
      }
      const { authUser } = this.props.auth;
      this.props.searchEventImage(inputJson, authUser.token);
    }
  };

  onChange = e => {
    if (e.type === 'click') {
      const { pagination } = this.state;
      this.fetch({ pagination });
    }
  };

  render() {
    const { loader } = this.props.eventImage;
    const { previewVisible, previewImage, previewTitle, pagination, eventImageList } = this.state;
    return (
      <Auxiliary>
        <PageHeader title="Event Images" navigateTo="/event-image/upload" linkName="Upload Event Image"/>
          <>
            <Row className="row-margin2">
              <Col>
                <Search
                  placeholder="Search by Name or Type"
                  allowClear
                  enterButton="Search"
                  size="large"
                  onSearch={this.onSearch}
                  onChange={this.onChange}
                />
              </Col>
            </Row>
            <Row className="row-margin2">
              <Col>
                <Table
                  className="gx-table-responsive"
                  columns={this.columns}
                  dataSource={eventImageList}
                  rowKey={record => record._id}
                  pagination={{
                    ...pagination,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    itemRender: itemRender,
                    size: 'small'
                  }}
                  loading={loader}
                  size={'middle'}
                  onChange={this.handleTableChange}
                />
              </Col>
            </Row>
          </>

        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt={previewTitle} style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </Auxiliary>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    eventImage: state.eventImage
  }
}

function mapDispathToProps(dispatch) {
  return bindActionCreators({ listEventImages, deleteEventImage, searchEventImage, resetEventImageType }, dispatch);
}

export default connect(mapStateToProps, mapDispathToProps)(EventImageList);

